/* hzo-swatches — op een kleurstaal tikken wisselt de foto op de kaart.

   Bewust één afhandelaar op het document in plaats van een custom element per
   kaart: dat werkt ook voor kaarten die later worden bijgeladen, en het hangt
   niet af van het moment waarop een element wordt opgewaardeerd.

   Zonder JavaScript blijft elk staal gewoon een link naar die variant, dus er
   gaat niets verloren als dit bestand niet laadt. */

(function () {
  if (window.__hzoSwatchesAan) return;
  window.__hzoSwatchesAan = true;

  /* ZWEVEN EN KIEZEN ZIJN TWEE VERSCHILLENDE DINGEN.
   *
   * Eerst deden ze allebei hetzelfde: `kies()` wisselde de foto, zette het actieve
   * staal én veranderde waar de kaart heen linkt. Bij zweven is dat laatste fout.
   * De muis die op weg naar de producttitel toevallig langs een staal schampt,
   * veranderde daarmee welk product je opende — je klikt op de titel en komt bij
   * een kleur die je nooit hebt gekozen.
   *
   * Zweven laat nu alleen de foto zien. Pas een klik legt de keuze vast. */

  function fotoTonen(staal) {
    var kaart = staal.closest('[data-hzo-kaart]');
    if (!kaart) return null;
    var foto = kaart.querySelector('.hzo-kaart__foto:not(.hzo-kaart__foto--twee)');
    if (!foto) return null;

    var srcset = staal.getAttribute('data-hzo-srcset');
    var src = staal.getAttribute('data-hzo-src');
    if (!srcset) return null;

    if (srcset !== foto.getAttribute('srcset')) {
      foto.setAttribute('srcset', srcset);
      if (src) foto.setAttribute('src', src);
      var alt = staal.getAttribute('data-hzo-alt');
      if (alt) foto.setAttribute('alt', alt);
    }
    return kaart;
  }

  function kies(staal) {
    var kaart = fotoTonen(staal);
    if (!kaart) return false;

    var alle = kaart.querySelectorAll('[data-hzo-staal]');
    for (var i = 0; i < alle.length; i++) {
      var aan = alle[i] === staal;
      alle[i].toggleAttribute('data-hzo-actief', aan);
      /* aria-current alleen op het gekozen staal. "false" erop zetten is geldig
         maar ruis: een schermlezer leest het voor bij elk ander staal. */
      if (aan) {
        alle[i].setAttribute('aria-current', 'true');
      } else {
        alle[i].removeAttribute('aria-current');
      }
    }

    var link = kaart.querySelector('[data-hzo-hoofdlink]');
    var href = staal.getAttribute('href');
    if (link && href) link.setAttribute('href', href);
    return true;
  }

  document.addEventListener('click', function (e) {
    /* Modifier-toetsen met rust laten: cmd-klik hoort een nieuw tabblad te openen. */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var staal = e.target.closest && e.target.closest('[data-hzo-staal]');
    if (!staal) return;
    if (kies(staal)) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  document.addEventListener('pointerover', function (e) {
    var staal = e.target.closest && e.target.closest('[data-hzo-staal]');
    if (staal) fotoTonen(staal);
  }, true);
})();
